
export const mapStateToProps = (state) => {
    return {
        current_route: state.currentRoute,
        currentPage: state.currentPage,        
        filters:state.filters
    }
  }